module.exports = __webpack_public_path__ + "img/contact.d61c0fc7.jpg";